import { Grid, TextField } from '@mui/material';

const ContactInformationSection = ({ t, userData, onSetAddress }) => (
  <Grid className="personal-data__card personal-data__card--contact">
    <h4 className="sub_head">{t('personalData.Contact_Information')}</h4>
    <Grid className="personal-data__card-head">
      <TextField
        label={t('personalData.phone')}
        placeholder={t('personalData.phone')}
        className="personal-data__text-field"
        value={(userData && userData.address)?.phoneNumber || ''}
        onChange={onSetAddress}
        name="phoneNumber"
        margin="normal"
        fullWidth
        InputLabelProps={{ shrink: true }}
      />
      <TextField
        label={t('personalData.Faxnumber')}
        placeholder={t('personalData.Faxnumber')}
        className="personal-data__text-field"
        value={(userData && userData.address)?.faxNumber || ''}
        onChange={onSetAddress}
        name="faxNumber"
        margin="normal"
        fullWidth
        InputLabelProps={{ shrink: true }}
      />
    </Grid>
  </Grid>
);

export default ContactInformationSection;
